import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { SettingService } from '@services';
@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisclaimerComponent {

  brandName: Signal<string> = computed(() => this.settingsService.brandSettings().name)
  copyright: Signal<string> = computed(() => this.settingsService.brandSettings().copyright)

  constructor(
    private readonly router: Router,
    private readonly settingsService: SettingService
  ) {
  }
  
  login() {
    this.router.navigateByUrl('/login');
  }

  home() {
    this.router.navigateByUrl('/home');
  }

}
